import Component from '../core/Component';
import { disableScrolling, enableScrolling } from '../services/Viewport'

export const STATES = {
    ACTIVE: 'is-active'
}
export default class CallOpener extends Component {
    constructor($element) {
        super($element);
    }

    prepare() {
        var self = this

        this.$element.on('mouseenter', event => {
            this.openCall()
        })

        this.$element.on('mouseleave', event => {
            this.closeCall()
        })

        if (window.outerWidth <= 768) {
            $(window).on('click', event => {
                var Elem = self.$element
                if (Elem.hasClass(STATES.ACTIVE) && !Elem.has(event.target).length) {
                    self.closeCall()
                }
            })

            this.$element.on('click', event => {
                event.preventDefault()
                event.stopPropagation()
                if (this.$element.hasClass(STATES.ACTIVE)) {
                    if (event.target.nodeName === "BUTTON") {
                        //close
                        this.closeCall()
                    }
                    if (event.target.href) {
                        //redirect
                        window.location = event.target.href
                    }
                } else {
                    this.openCall()
                }
            })
        }

        var callupShown = window.localStorage.getItem('showCallUp')
        if (!callupShown) {
            window.localStorage.setItem('showCallUp', true)
        }

        if (!callupShown) {
            //open call after 5s
            setTimeout(function () {
                if (!self.$element.hasClass(STATES.ACTIVE)) {
                    self.$element.addClass(STATES.ACTIVE)
                }
                setTimeout(() => {
                    self.$element.removeClass(STATES.ACTIVE)
                }, 6000)
                    window.localStorage.setItem('showCallUp', false)
            }, 5000)
        }

    }
    openCall() {
        // open
        event.preventDefault()
        disableScrolling()
        this.$element.addClass(STATES.ACTIVE)
    }
    closeCall() {
        // close
        enableScrolling()
        this.$element.removeClass(STATES.ACTIVE)
    }
}



// WEBPACK FOOTER //
// ./components/CallOpener.js